/// <amd-module name="TFS/Admin/Common/RestClient/OrganizationSettings" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\client\adminengagement\clientgeneratorconfigs\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as OrganizationSettings from "../Contracts/OrganizationSettings";

export interface IOrganizationSettingsRestClient extends IVssRestClient {
    /**
     * @param tenantId - 
     */
    getDisconnectedUsers(tenantId?: string): Promise<OrganizationSettings.DisconnectedUsers>;
}

class OrganizationSettingsRestClient extends RestClientBase implements IOrganizationSettingsRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * @param tenantId - 
     */
    public async getDisconnectedUsers(
        tenantId?: string
        ): Promise<OrganizationSettings.DisconnectedUsers> {

        const queryValues: any = {
            tenantId: tenantId
        };

        return this.beginRequest<OrganizationSettings.DisconnectedUsers>({
            apiVersion: "5.1-preview.1",
            routeTemplate: "_apis/OrganizationSettings/DisconnectedUser",
            queryParams: queryValues
        });
    }

}

export const OrganizationSettingsClientName = "IOrganizationSettingsRestClient";

export function getOrganizationSettingsClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IOrganizationSettingsRestClient {
    return pageContext.getRestClient<IOrganizationSettingsRestClient>(OrganizationSettingsClientName, options);
}

RestClients.add(OrganizationSettingsClientName, { 
    factory: OrganizationSettingsRestClient
});
